import { render } from "./question.vue?vue&type=template&id=02a26d1a&scoped=true"
import script from "./question.vue?vue&type=script&lang=js"
export * from "./question.vue?vue&type=script&lang=js"

import "./question.vue?vue&type=style&index=0&id=02a26d1a&lang=scss&scoped=true"
import "./question.vue?vue&type=style&index=1&id=02a26d1a&lang=css"

import exportComponent from "D:\\workCode\\web-backEnd\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02a26d1a"]])

export default __exports__